import moment from 'moment-timezone';

export default {
  methods: {
    showUpdateNotification({ record, oldRecord }) {
      if (oldRecord.id === undefined) { return; }
      if (!record.updatedBy || !record.updatedAt) { return; }
      if (this.$store.state.me.account.id !== record.updatedBy.id) {
        const time = moment(record.updatedAt).format('h:mm A');
        this.$notify({
          verticalAlign: 'top',
          horizontalAlign: 'right',
          message: `Updated by <b>${record.updatedBy.fullName}</b> at ${time}`,
          icon: 'tim-icons icon-bell-55',
          timeout: 0,
        });
      }
    },
  },
};
